//-----------------------
// Cookie Notification
// By Mediaworkers 2013
//-----------------------


function storageEnabled() {
    try {
        localStorage.setItem("__localstoragetest", "data");
        localStorage.removeItem('__localstoragetest');
        localStorage.removeItem('__test'); //legacy
    } catch (e) {
        if (/QUOTA_?EXCEEDED/i.test(e.name)) {
            return false;
        }
    }
    return true;
}

function cookieNotification() {
    if (storageEnabled()) {

        var cookieContainer = ".cookie-notification";
        var cookieAccept = ".cookie-notification__accept";

        //Detect if browser supports HTML5 storage. Note: IE7 is not supported.
        if (typeof (Storage) !== "undefined") {

            //Dont show the notification box, if the browser has localStorage data with the name "userAcceptsCookies" .
            if (localStorage.getItem('userAcceptsCookies'))
                return;

            //Show the notification box
            $(cookieContainer).show().animate({
                "bottom": "0"
            });

            //On button click, set local storage and hide the notification box
            $(cookieAccept).click(function (e) {

                e.preventDefault();

                localStorage.setItem('userAcceptsCookies', 'yes');

                //Animate
                $(cookieContainer).animate({
                    "bottom": "-200px"
                }, function () {
                    $(cookieContainer).hide();
                });
            });

        }

        else {
            console.log("LocalStorage? ¯\\_(ツ)_/¯");
        }

    }
}

window.enhance.loadJS.ready(['jQuery'], {
    success: function () {
        cookieNotification();
    }
});